import { render } from "./professionKnowledgeView.vue?vue&type=template&id=69f28366"
import script from "./professionKnowledgeView.vue?vue&type=script&lang=js"
export * from "./professionKnowledgeView.vue?vue&type=script&lang=js"

import "./professionKnowledgeView.vue?vue&type=style&index=0&id=69f28366&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__